/* eslint-disable max-lines-per-function */
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from 'revamp/reusable-components/tooltip/tooltip'
import Heatbar from '../../USStocksDetail/Heatbar'
import { StencilCDNImage } from '@/components/Common/StencilImage'
import { RUPEE_SYMBOL } from '@/root/constants'
import { IMetaInfo, Performance } from '@/components/Stocks/Widgets/types'
import { formatNumberToCommaSeparatedString } from '@/root/utils/common/numbers/format-number-to-string'
import InStockL2Heading from '@/components/Stocks/Pages/InStockDetailPageV2/InL2Heading'

interface Props {
  tooltip?: string
  heading?: string
  meta_info?: IMetaInfo
  disableCurrencyUnit?: boolean
  subheading?: string
}

export default function NewPerformance(props: Performance & Props) {
  const {
    tooltip,
    returns,
    market_stats,
    heading,
    performance_ranges,
    meta_info,
    disableCurrencyUnit = false,
    subheading = '',
  } = props
  if (!props.performance_ranges?.length) {
    return null
  }

  const returnData = returns?.map(item => {
    return {
      ...item,
      key: item.label,
      value: `${item.value} %`,
      color:
        item.value && Math.sign(parseFloat(item.value.toString())) === -1
          ? '#DF3C27'
          : '#33A34D',
    }
  })
  const marketsData = market_stats?.map(item => {
    return {
      ...item,
      key: item.label,
      value_rupees: item.value,
    }
  })

  const isPositiveNumber = (inputString: string) => {
    const numericString = inputString.replace(/[^0-9.-]/g, '')
    const number = parseFloat(numericString)
    return number > 0
  }

  const getSubType = (subtype: string) => {
    return subtype.split('-').join(' ')
  }

  return (
    <section>
      <div className="flex items-center justify-between">
        <InStockL2Heading heading={heading} subheading={subheading} />

        {tooltip && (
          <Tooltip>
            <TooltipTrigger>
              <StencilCDNImage
                src="https://indcdn.indmoney.com/public/images/info_new.png"
                width={18}
                height={18}
                onClick={() => {}}
              />
            </TooltipTrigger>

            <TooltipContent>
              <div
                className="bg-brand-white border-1 shadow-one w-56 p-2 text-xs"
                dangerouslySetInnerHTML={{
                  __html: tooltip,
                }}
              />
            </TooltipContent>
          </Tooltip>
        )}
      </div>
      <ul className="mt-5 flex flex-col gap-5 md:gap-10">
        {performance_ranges?.map((el, index) => {
          return (
            <li key={index} className="pb-4">
              <div className="mb-1 flex flex-row justify-between">
                {el.down && (
                  <p className="text-13px text-brand-grey-base">{`${getSubType(
                    el.sub_type ?? '',
                  )}'s Low`}</p>
                )}
                {/* <p className="text-brand-grey-base flex flex-col gap-1 px-2 text-center text-xs lg:flex-row lg:gap-2 lg:text-sm">
                    {el.voltl_text && <span>{el.voltl_text}:</span>}
                    {el.voltl && <span>{`${el.voltl.toFixed(2)}%`}</span>}
                  </p> */}
                {el.up && (
                  <p className="text-13px text-brand-grey-base">{`${getSubType(
                    el.sub_type ?? '',
                  )}'s High`}</p>
                )}
              </div>
              <Heatbar
                title={el.label}
                leftPercentage={el.arrow_position}
                rightValue={
                  el.max
                    ? `${
                        disableCurrencyUnit
                          ? ''
                          : meta_info
                          ? meta_info.currency_symbol
                          : RUPEE_SYMBOL
                      }${formatNumberToCommaSeparatedString(el.max)}`
                    : ''
                }
                leftValue={
                  el.min
                    ? `${
                        disableCurrencyUnit
                          ? ''
                          : meta_info
                          ? meta_info.currency_symbol
                          : RUPEE_SYMBOL
                      }${formatNumberToCommaSeparatedString(el.min)}`
                    : ''
                }
                // arrowValue={
                //   el.val
                //     ? `${
                //         meta_info ? meta_info.currency_symbol : RUPEE_SYMBOL
                //       }${formatNumberToCommaSeparatedString(el.val)}`
                //     : ''
                // }
              />
              {/* <div className="mt-6 flex items-center justify-between">
                  {el.down && (
                    <div className="flex items-center gap-2">
                      {el.down && (
                        <StencilCDNImage
                          alt="downward going graph"
                          src="https://indcdn.indmoney.com/cdn/images/fe/downward-going-graph-icon.png"
                          width={32}
                          height={32}
                        />
                      )}

                      <div className="flex flex-col-reverse gap-0 lg:flex-row lg:gap-2">
                        <p className="text-sm font-semibold">
                          {`${el.down.toFixed(2)}%`}
                        </p>
                      </div>
                    </div>
                  )}

                  {el.up && (
                    <div className="flex items-center gap-2">
                      <div className="flex flex-col gap-0 lg:flex-row lg:gap-2">
                        <p className="text-sm font-semibold">{`${el.up.toFixed(
                          2,
                        )}%`}</p>
                      </div>

                      {el.up && (
                        <StencilCDNImage
                          alt="downward going graph"
                          src="https://indcdn.indmoney.com/cdn/images/fe/upward-going-graph-icon.png"
                          width={32}
                          height={32}
                        />
                      )}
                    </div>
                  )}
                </div> */}
            </li>
          )
        })}
      </ul>
      <div className="relative mt-10 flex flex-col justify-center gap-x-32 md:mt-20 md:flex-row">
        <div className="absolute left-1/2 hidden h-full w-[1px] -translate-x-1/2 bg-gray-200 md:block" />
        {/* RETURNS TABLE */}
        {!!returnData?.length && (
          <table className="h-full w-full md:w-1/2">
            <thead className="hidden md:block">
              <tr className="h-12">
                <td className="text-sm font-medium">Returns %</td>
                <td />
              </tr>
            </thead>
            <tbody>
              {returnData.map(({ key, value, color }, index) => (
                <tr
                  className="border-t-1 border-grey-tertiary h-12"
                  key={index}
                >
                  <td className="text-grey-dark text-left text-sm font-normal">
                    {key}
                  </td>
                  <td
                    className="text-right text-sm font-medium"
                    style={{ color }}
                  >
                    {/* {icon && (
                      <span className="mr-1">
                        <StencilCDNImage
                          src={icon.png}
                          width={8}
                          height={8}
                          alt="Return data"
                        />
                      </span>
                    )} */}
                    {isPositiveNumber(value) ? `+ ${value}` : value}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {/* MARKETS TABLE */}
        {!!marketsData?.length && (
          <table className="h-full w-full md:inline-table md:w-1/2">
            <thead className="hidden md:block">
              <tr className="h-12">
                <td className="text-sm font-medium">Market Stats</td>
                <td />
              </tr>
            </thead>
            <tbody>
              {marketsData.map(({ key, value_rupees }, index) => (
                <tr
                  className="border-t-1 border-grey-tertiary h-12"
                  key={index}
                >
                  <td className="text-grey-dark text-left text-sm font-normal">
                    {key}
                  </td>
                  <td className="text-right text-sm font-medium">
                    {disableCurrencyUnit
                      ? ''
                      : meta_info
                      ? meta_info.currency_symbol
                      : ''}
                    {value_rupees}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </section>
  )
}
